import React, { Component } from "react";
import { connect } from "react-redux";
// import { bindActionCreators } from "redux";
import { withStyles } from "@mui/styles";

import UpdatePlanSteps from "./UpdatePlanSteps";
import Enums from "../../../utils/Enums";

class UpdatePlan extends Component {
  constructor(props) {
    super(props);
    this.mainRef = element => {
      this.main = element;
    };
  }

  componentDidMount() {
    if (this.props.user && this.props.user.status === Enums.STATUS.SUBMITTED) {
      this.props.history.replace("/auth/dashboard");
    }
  }

  render() {
    const { navDrawerOpen, history } = this.props;
    return (
      <main ref={this.mainRef}>
        <UpdatePlanSteps navDrawerOpen={navDrawerOpen} history={history} />
      </main>
    );
  }
}

const styles = theme => ({
  root: {}
});

function mapStateToProps(state) {
  return { user: state.user };
}

function mapDispatchToProps(dispatch) {
  return {};
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles, { withTheme: true })(UpdatePlan));
